import { MERKLE_PROOF_ENDPOINT } from '../constants';
export async function getMerkleProof(leaf, root) {
    const response = await fetch(`${MERKLE_PROOF_ENDPOINT}?leaf=${leaf}&root=${root.replace(/^0x/, '')}`);
    return (await response.json());
}
